<template>
  <div class="retired-container m-4 p-4">
    <div class="retired-content">
      <h1 class="title">Microarray Elements Tool Retired</h1>
      <p class="message">
        The Microarray Elements mapping tool has been retired.
      </p>
      <p class="message">
        Microarray mapping files are available on the
        <router-link to="/download/list?dir=Microarrays"
          >Downloads page</router-link
        >, along with README files describing the mappings. The Arabidopsis
        community has largely moved to newer technologies for transcriptomic
        analysis.
      </p>
      <router-link to="/download/list?dir=Microarrays" class="home-link"
        >Go to Microarray Downloads</router-link
      >
    </div>
  </div>
</template>

<script>
// TAIR3-662: tombstone page for the retired bulk microarray element mapping
// tool (legacy /tools/bulk/microarray/index.jsp).
export default {
  name: "MicroarrayRetired",
};
</script>

<style scoped>
.retired-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: #f9f9f9;
}

.retired-content {
  text-align: center;
  max-width: 600px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.title {
  color: #333;
  margin-bottom: 20px;
}

.message {
  color: #333;
  line-height: 1.6;
  margin-bottom: 20px;
}

.home-link {
  display: inline-block;
  background-color: #1976d2;
  color: #fff;
  padding: 10px 15px;
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.3s ease;
}

.home-link:hover {
  background-color: #135ba1;
}
</style>
